import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import * as _ from 'lodash';


@Component({
  standalone: false,
  selector: 'app-patch-dispatch-error-modal',
  templateUrl: './patch-dispatch-error-modal.component.pug',
  styleUrls: ['./patch-dispatch-error-modal.component.scss']
})
export class PatchDispatchErrorModalComponent implements OnInit {

  @Input() data:any;
  failures:Array<any>=[];
  successes:Array<any>=[];
  patchFailures:Array<any>=[];
  patchSuccesses:Array<any>=[];

  constructor() { }

  ngOnInit() {

    const allTheShittyCreationGroups = [...this.data.response.errors.create_errors];

    let allTheShittyCreationThings = [];

    allTheShittyCreationGroups.forEach((createErrorGroup) => {
      createErrorGroup.errors.forEach((createError) => {
        if(typeof createError == 'string'){
          allTheShittyCreationThings.push(createError);
        }else if(Array.isArray(createError)){
          allTheShittyCreationThings.push(...createError);

        }else if(createError instanceof Object){
          if(createError.event_errors != null){
            allTheShittyCreationThings.push(...createError.event_errors, ...createError.event_node_errors, ...createError.event_node_workflow_errors);
          }else{
            console.log("CreateError Unexpected Object: " +JSON.stringify(createError));
          }
        }


      });
    });

      //[...this.data.response.errors.create_errors.event_errors, ...this.data.response.errors.create_errors.event_node_errors, ...this.data.response.errors.create_errors.event_node_workflow_errors];
    const whatLittleWeCreatedRightGroups = this.data.response.data.created;
    let whatLittleWeCreatedRight = [];
    whatLittleWeCreatedRightGroups.forEach((createGroup) => {
      whatLittleWeCreatedRight.push(...createGroup);
    });


    whatLittleWeCreatedRight.forEach((o) => {
      this.successes.push(o.event.event_name)
    });

    allTheShittyCreationThings.forEach((o) => {

      var obj = {label: this.data.postObj.event_name + ' ' + o.portfolio_name.en_US, description: o.detail + ' and event_id=' + o.ems_rollback_event_id, overlap_id: o.ems_rollback_event_id};
      this.failures.push(obj)
    });

    const allTheShittyPatchedThings = Object.assign({},...this.data.response.errors.patch_errors);
    const whatLittleWePatchedRight = Object.assign({},...this.data.response.data.patched);



    Object.keys(whatLittleWePatchedRight).forEach((patchEventId) => {
      this.patchSuccesses.push({
        event_id: patchEventId,
        event_name: whatLittleWePatchedRight[patchEventId].event_name,
        pending_nodes_activated: Object.values(whatLittleWePatchedRight[patchEventId].pending_nodes_activated).map((activatedNode) => {
          // @ts-ignore
          return activatedNode.registration_identifier
        }).join(', '),
        activation_start_time: whatLittleWePatchedRight[patchEventId].activation_start_time,
        activation_end_time: whatLittleWePatchedRight[patchEventId].activation_end_time
      });
    });

    Object.keys(allTheShittyPatchedThings).forEach((patchEventId) => {
      this.patchFailures.push({
        event_id: patchEventId,
        event_name: allTheShittyPatchedThings[patchEventId].event_name,
        activation_error: allTheShittyPatchedThings[patchEventId].activation_error,
        selected_regs_not_pending: Object.values(allTheShittyPatchedThings[patchEventId].selected_regs_not_pending).map((selectedNotPendingNode) => {
          // @ts-ignore
          return selectedNotPendingNode.registration_identifier
        }).join(', '),
      });
    });
  }

  goToEvent(eventId){
    const url = '/event/' + eventId;
    window.open(url, '_blank');
  }

  onClose(){
    this.data.close.apply();
  }

}
